import gfWindowInfo from "@/components/gfWindowInfo.vue";
import store from "@/store"

let infowindowInstance = null;

// 定义自定义覆盖物的构造函数  
function ninfowindow(info){
  this._center = info.point;
  this._info = info
}
// 继承API的BMap.Overlay
ninfowindow.prototype = new BMap.Overlay();


// 实现初始化方法  
ninfowindow.prototype.initialize = function(map){
  this._map = map;
  var div = document.createElement("div");
  div.id = "ninfowindow"
  div.style.position = "absolute";
  
  map.getPanes().markerPane.appendChild(div);
  var content  = $Vue.extend(gfWindowInfo);



  infowindowInstance = new content({
    propsData: {
      sensorData: this._info,
      handleClose: ()=>{ this.close(map) },
      yuzhi:store.state.yuzhi
    }
  }).$mount();
  this._div = div;
  this._div.append(infowindowInstance.$el)
  div.parentElement.style.zIndex= 1000
  return div;
}

// 实现绘制方法   
ninfowindow.prototype.draw = function(){    
  // 根据地理坐标转换为像素坐标，并设置给容器    
  var position = this._map.pointToOverlayPixel(this._center);    
  this._div.style.left = position.x - 163 + "px";    
  this._div.style.top = position.y - 276 + "px";
  // this._div.style.top =  "-122px";

}

ninfowindow.prototype.open = function (map) {
  // if (map.ninfowindow) {
  //   map.removeOverlay(map.ninfowindow)
  // }
  map.addOverlay(this)
  map.ninfowindow = this
}

ninfowindow.prototype.close = function (map) {
  map.removeOverlay(this)
}

let overlays = []

function openGfinfoWindow(info, map) {
  var overlay = new ninfowindow(info)
  overlays.push(overlay)
  overlay.open(map)
  return overlay;
}

function closeAll(map) {
  overlays.forEach(e=>e.close(map))
}

export { openGfinfoWindow , closeAll}



// WEBPACK FOOTER //
// ./src/utils/gfMarkerInfo.js